import { useState, useEffect } from 'react';
import { getPostsForSite, Category } from '../../lib/directus';

export const useCategories = (domain: string) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const posts = await getPostsForSite(domain);
        const categoryMap = new Map<number, Category>();
        if (Array.isArray(posts)) {
          posts.forEach((post: any) => {
            if (post.categories && Array.isArray(post.categories)) {
              post.categories.forEach((cat: any) => {
                const category = cat.categories_id;
                if (category && category.id && !categoryMap.has(category.id)) {
                  categoryMap.set(category.id, category);
                }
              });
            }
          });
        }
        setCategories(Array.from(categoryMap.values()));
        setError(null);
      } catch (err) {
        console.error('Ошибка загрузки категорий:', err);
        setError('Не удалось загрузить категории');
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [domain]);

  return { categories, loading, error };
};